import * as React from 'react';
import { type Context } from 'react';
import { type IntlShape } from './types.ts';
import { type AsyncLocalStorage } from 'node:async_hooks';
import { IntlProvider } from './IntlProvider.tsx';

let asyncLocalStorage: AsyncLocalStorage<IntlShape>;
export function setAsyncLocalStorage(val: AsyncLocalStorage<IntlShape>): void {
    asyncLocalStorage = val;
}

const { createContext, useContext: reactClientUseContext } = React;

let IntlContext: Context<IntlShape | null>;

let useContext: typeof reactClientUseContext;
if (typeof createContext !== 'undefined') {
    IntlContext = createContext<IntlShape | null>(null);
    IntlContext.displayName = 'DibsIntlContext';
    useContext = reactClientUseContext;
} else {
    //@ts-expect-error
    useContext = function () {
        return asyncLocalStorage.getStore();
    };
}

export { IntlContext, IntlProvider };

export function useIntl(): IntlShape {
    const intl = useContext(IntlContext);

    if (!intl) {
        throw new Error(
            '[dibs-react-intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.'
        );
    }

    return intl;
}
